const investmentTypeHistoryLang = {
	title_investments_timeline: {
		tag: 'investment.type.history.title_investments_timeline',
		fr: "Chronologie d'investissement",
		en: 'Investment timeline',
	},
	title_investments_timeline_tooltip: {
		tag: 'investment.type.history.title_investments_timeline_tooltip',
		fr: 'Engagements et appels de fonds',
		en: 'Commitments & capital calls',
	},
	title_jcurve_visualization: {
		tag: 'investment.type.history.title_jcurve_visualization',
		fr: 'Flux financiers',
		en: 'Cash flows',
	},
	title_jcurve_visualization_tooltip: {
		tag: 'investment.type.history.title_jcurve_visualization_tooltip',
		fr: "Cashflows cumulés = Distributions cumulés - Appels de fonds cumulés - Primes d'appel",
		en: 'Cumulated cashflows = Cumulated distributions - Total capital calls - Captial calls premium',
	},
	title_total_value: {
		tag: 'investment.type.history.title_total_value',
		fr: 'Valeur totale & Capital net',
		en: 'Total value & Capital at work',
	},
	title_total_value_tooltip: {
		tag: 'investment.type.history.title_total_value_tooltip',
		fr: 'Valeur totale = NAV + Distributions<br/>Capital net = Capital appelé moins les amortissements distribués',
		en: 'Total value = NAV + Distributions<br/>Capital at work = Called capital minus distributed return of capital',
	},
	title_last_inflows_outflows_engagements: {
		tag: 'investment.type.history.title_last_inflows_outflows_engagements',
		fr: 'Dernières entrées, sorties et engagements',
		en: 'Last inflows, outflows & engagements',
	},
	title_multiple_net_of_fees: {
		tag: 'investment.type.history.title_multiple_net_of_fees',
		fr: 'Multiple net',
		en: 'Multiple (net of fees)',
	},
	title_multiple_net_of_fees_tooltip: {
		tag: 'investment.type.history.title_multiple_net_of_fees_tooltip',
		fr: '(NAV+ total des distributions à date) / capital appelé total',
		en: '(NAV + as-on-date total distributions ) / total capital call',
	},
	timeline_capital_calls: {
		tag: 'investment.type.history.timeline_capital_calls',
		fr: 'APPELS DE FONDS',
		en: 'CAPITAL CALLS',
	},
	timeline_commitments: {
		tag: 'investment.type.history.timeline_commitments',
		fr: 'ENGAGEMENTS',
		en: 'COMMITMENTS',
	},
	graph_legend_cumulated_distributions: {
		tag: 'investment.type.history.graph_legend_cumulated_distributions',
		fr: 'Distributions cumulées',
		en: 'Cumulated distributions',
	},
	graph_legend_capital_calls: {
		tag: 'investment.type.history.graph_legend_capital_calls',
		fr: 'Appels de fonds cumulés',
		en: 'Total capital calls',
	},
	graph_legend_dry_powder: {
		tag: 'investment.type.history.graph_legend_dry_powder',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},
	graph_legend_cumulated_cashflows: {
		tag: 'investment.type.history.graph_legend_cumulated_cashflows',
		fr: 'Cashflows cumulés',
		en: 'Cumulated cashflows',
	},
	graph_legend_total_value: {
		tag: 'investment.type.history.graph_legend_total_value',
		fr: 'Valeur totale',
		en: 'Total value',
	},
	graph_legend_total_capital_calls: {
		tag: 'investment.type.history.graph_legend_total_capital_calls',
		fr: 'Appels de fonds cumulés',
		en: 'Total capital calls',
	},
	graph_legend_cumulated_net_called_capital: {
		tag: 'investment.type.history.graph_legend_cumulated_net_called_capital',
		fr: 'Capital net',
		en: 'Capital at work',
	},
	graph_legend_max_cumulated_net_called_capital: {
		tag: 'investment.type.history.graph_legend_max_cumulated_net_called_capital',
		fr: 'Capital net max',
		en: 'Max capital at work',
	},
	graph_legend_multiple_net_of_fees: {
		tag: 'investment.type.history.graph_legend_multiple_net_of_fees',
		fr: 'Multiple',
		en: 'Multiple',
	},
};

export default investmentTypeHistoryLang;
